/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connector: NonNullable<unknown>, creator: NonNullable<unknown> }} Agent_Access_UnpinnedInputs */



/**
* | output |
* | --- |
* | "Its abilities use {connector}, but no {connector} connection is picked for it: ask {creator}." |
*
* @param {Agent_Access_UnpinnedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_unpinned = /** @type {((inputs: Agent_Access_UnpinnedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_UnpinnedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seine Fähigkeiten nutzen ${i?.connector}, aber es ist keine ${i?.connector}-Verbindung für ihn ausgewählt: Fragen Sie ${i?.creator}.`)
	return /** @type {LocalizedString} */ (`Its abilities use ${i?.connector}, but no ${i?.connector} connection is picked for it: ask ${i?.creator}.`)
});